var $bfa21259fd564cea$exports = {};
$bfa21259fd564cea$exports = {
  "collapse": " Skupi",
  "expand": "Pro\u0161iri"
};
export { $bfa21259fd564cea$exports as default };